<script lang="ts">
  import { settingsStore } from "../lib/stores/settings";
  import Add from "../assets/icons/add.svg";

  export let file: File | null = null;
  export let selectFileLabel: string;
  export let handleUploadedFile: (event: Event) => void;  
</script>

<div class="file-option flex flex-col lg:flex-row space-between items-center gap-8" aria-label="image uploader">
  {#if file && file.type?.startsWith("image")}
    <div class="border-[var(--color-grayscale-30)] border-[0.0625rem] border-solid bg-[color:var(--white)] w-[9.375rem] h-[9.375rem] rounded-[0.25rem] overflow-hidden relative">
      <img src={URL.createObjectURL(file)} alt={`${file.name} image`} class="w-full h-full object-contain" />
    </div>
  {/if}

  <div>
    <button class="cursor-pointer w-full flex items-center flex-col lg:block" aria-label={selectFileLabel}>
      <label class="border-[0.125rem] border-dotted w-72 p-[1.2rem] max-w-full cursor-pointer flex flex-row items-center gap-2" for="file-upload">
        <span> <img src={Add} alt="add" class="w-6 h-6 h-[1.2rem] w-[1.2rem]" /> </span>
        {selectFileLabel}
      </label>
      {#if file}
        <p class="lg:text-left mt-2 overflow-hidden whitespace-nowrap text-ellipsis text-wrap">{file.name}</p>
      {/if}
    </button>
    <input
      type="file"
      id="file-upload"
      on:change={handleUploadedFile}
      accept={`${($settingsStore.uploadMimeTypes ?? []).join(", ")}`}
      class="hidden" />
  </div>
</div>
